// Shared option lists used across the seller form, homepage search, and Browse filters.

export const CONDITIONS = [
    "New",
    "New with tags",
    "New (open box)",
    "Mint condition",
    "Like new",
    "Refurbished",
    "Certified pre-owned",
    "Used - Excellent",
    "Used - Good",
    "Used - Fair",
    "Poor condition",
    "For parts / not working",
];

export const SORTS = [
    { value: "ending_soon", label: "Ending soon" },
    { value: "newly_listed", label: "Newly listed" },
    { value: "price_low", label: "Price: low to high" },
    { value: "price_high", label: "Price: high to low" },
    { value: "most_bidders", label: "Most bidders" },
];

export const RATING_OPTIONS = [
    { value: "4.5", label: "4.5 stars & up" },
    { value: "4", label: "4 stars & up" },
    { value: "3", label: "3 stars & up" },
];
